import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import type { OnboardingData } from "@/pages/Onboarding";
import { useState } from "react";

interface OrganizationWebsiteProps {
  formData: OnboardingData;
  updateFormData: (data: Partial<OnboardingData>) => void;
  handleNext: () => void;
}

export default function OrganizationWebsite({
  formData,
  updateFormData,
  handleNext,
}: OrganizationWebsiteProps) {
  const [error, setError] = useState("");

  const validateUrl = (url: string) => {
    if (!url) {
      setError("URL is required");
      return false;
    }

    try {
      const urlObj = new URL(url);
      if (!["http:", "https:"].includes(urlObj.protocol)) {
        setError("URL must start with http:// or https://");
        return false;
      }
      setError("");
      return true;
    } catch {
      setError("Please enter a valid URL");
      return false;
    }
  };

  const handleChange = (value: string) => {
    updateFormData({ website_url: value });
    if (value) validateUrl(value);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && validateUrl(formData.website_url)) {
      handleNext();
    }
  };

  return (
    <div className="w-full min-w-md">
      <div className="w-full">
        <div className="space-y-6">
          <div className="space-y-2">
            <Label htmlFor="website_url">Your Website URL</Label>
            <Input
              id="website_url"
              name="website_url"
              type="url"
              placeholder="https://example.com"
              value={formData.website_url}
              onChange={(e) => handleChange(e.target.value)}
              onKeyDown={handleKeyDown}
              onBlur={() => validateUrl(formData.website_url)}
              className={
                error
                  ? "border-destructive focus-visible:ring-destructive/20"
                  : ""
              }
              autoFocus
              required
            />
            {error && <p className="text-destructive text-sm mt-1">{error}</p>}
          </div>
        </div>
      </div>
    </div>
  );
}
